import Api from '@/services/Api';

const state = {
    config: null,
    loading: false
};

const mutations = {
    SET_CONFIG(state, config) {
        state.config = config;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    }
};

const actions = {
    async loadConfig({ commit, state }) {
        if (state.config) return state.config;
        
        commit('SET_LOADING', true);
        try {
            const { data } = await Api().get('/tenants/config');
            commit('SET_CONFIG', data);
            
            if (data.primaryColor) {
                document.documentElement.style.setProperty('--primary-color', data.primaryColor);
            }
            if (data.secondaryColor) {
                document.documentElement.style.setProperty('--secondary-color', data.secondaryColor);
            }
            if (data.favicon) {
                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.head.appendChild(link);
                }
                link.href = data.favicon;
            }
            
            return data;
        } catch (error) {
            console.error('Erro ao carregar configurações do tenant:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    }
};

const getters = {
    config: state => state.config,
    loading: state => state.loading,
    logo: state => state.config?.logo,
    favicon: state => state.config?.favicon,
    primaryColor: state => state.config?.primaryColor,
    secondaryColor: state => state.config?.secondaryColor,
    uiOverrides: state => state.config?.ui_overrides || {},
    featureFlags: state => state.config?.feature_flags || {},
    getTenant: state => state.config || {},
    getFeatureFlag: state => (flagName) => state.config?.feature_flags?.[flagName] || false,
    getNavLabel: state => (item) => state.config?.ui_overrides?.nav_labels?.[item.key] || item.name,
    getTabLabel: state => (tabKey) => state.config?.ui_overrides?.tab_labels?.[tabKey] || null,
    getTabOrder: state => state.config?.ui_overrides?.tab_order || null,
    getTenantText: state => (key, defaultValue = '') => {
        const tenantTexts = state.config?.ui_overrides?.texts || {};
        return tenantTexts[key] || defaultValue;
    },
    getRegisterNewUsers: state => state.config?.feature_flags?.registerNewUsers !== undefined ? state.config.feature_flags.registerNewUsers : false
};

export default {
    state,
    mutations,
    actions,
    getters
};
